import React from "react";
import TextField from "./TextField/TextField";
function PrivateNativeDate({ ...props }) {
    return (React.createElement(TextField, { ...props, inputProps: {
            min: props.min,
            max: props.max,
            step: props.step,
        } }));
}
export default PrivateNativeDate;
//# sourceMappingURL=PrivateNativeDate.js.map